import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { PanierService, TrackingService, Ota, ComparatorsService, Logger, WindowRefService } from '@app/core';
import { ILineV2, ICombine } from '@app/shared';
import { min, max, values, map, chain, has } from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { ActionType } from '@app/state/general/app.actions';
import { StateGenaral } from '@app/state/general/app.state';

const log = new Logger('SelectStock');

@Component({
    selector: 'app-select-stock',
    templateUrl: './select-stock.component.html',
    styleUrls: ['./select-stock.component.scss']
})
export class SelectStockComponent implements OnInit, OnDestroy {
    @ViewChild('stockSelect') elemSelect: ElementRef;
    @Input() model: ILineV2;
    @Input() stockSelect: { value: number };
    @Input() events$: Observable<any>;
    private eventsSubscription: Subscription;
    //stockRoom: number;
    stocks: {} = {};
    stocksRoom: {} = {};
    idCentral: number;
    showCounter: boolean = false;

    constructor(private store: Store<any>, private panierService: PanierService, private comparatorsService: ComparatorsService, private trackingService: TrackingService, private winRef: WindowRefService) {
        this.idCentral = this.winRef.appConfigSite.idCentral;
    }

    ngOnInit() {
        this.eventsSubscription = this.events$.subscribe((data: { offreId: number }) => {
            /*
            let stock = this.panierService.getStockByRoomLine(this.model.room.id, this.model.line)
            if (stock == 0) {
                this.elemSelect.nativeElement.value = "1";
                this.selectedStock("1");
            }
            //*/
            this.addInCart();
            this.panierService.changeOffer(this.model.room.id, this.model.line, data.offreId)
        });
        this.model.newTitle = this.model.engine.combine.roomtype_ota.room_name;
        this.model.surface = this.model.engine.combine.metrage;
        this.store.select('appState').subscribe((data: { response: Ota }) => {
            //info : dispatch combine ça  marche pas 
            if (!!data.response && !!data.response.enginesearch /*&& data.response.enginesearch == this.model.engine.combine.ota*/) {
                let stocks = this.comparatorsService.getStockRoomByOta(this.model.room.id);
                this.stocks = chain(stocks).mapValues(this.model.room.id)
                    .mapValues(values => {
                        let r = chain(values).map(v => {
                            let t = chain(v).map(val => {
                                return chain(val).map('stock').max().value();
                            }).max().value();
                            return t;
                        }).max().value();
                        return r;

                    })
                    .value();
                this.model.newTitle = this.model.engine.combine.roomtype_ota.room_name;
                this.model.surface = this.model.engine.combine.metrage;
            }
        });
        this.store.select('appStateGenaral').subscribe((data: StateGenaral) => {
            if (data.type === ActionType.incrementStockCombine && data.incrementStockCombine.indexSearch === this.model.engine.combine.indexSearch) {
                this.addInCart();
            }
        });
        //Selected automatic last value after click btn "show more" 
        setTimeout(() => {
            let selectedCount = this.panierService.getStockByIndex(this.model.engine.combine.indexSearch);
            this.stockSelect.value = selectedCount;
            this.elemSelect.nativeElement.value = selectedCount;
        });
    }

    ngOnDestroy() {
        this.eventsSubscription.unsubscribe();
    }

    addInCart() {
        let newStock = (this.stockSelect.value + 1),
            minStock = min(values(this.maxStockArray));
        if (newStock <= minStock) {
            this.stockSelect.value = newStock;
            this.elemSelect.nativeElement.value = newStock
            this.selectedStock(this.stockSelect.value.toString());
        }
        window.postMessage({ eventId: "eventShowPanier", data: { lengthRooms: this.panierService.getNbrRooms() } }, "*");
    }

    /**
     * convete string to integer (used in view)
     * @returns number
     */
    convertToInt(value: string): number {
        return parseInt(value);
    }

    resetRoom() {
        this.elemSelect.nativeElement.value = "0";
        this.selectedStock("0");
        this.showCounter = false;
        window.postMessage({ eventId: "eventShowPanier", data: { lengthRooms: this.panierService.getNbrRooms() } }, "*");
    }

    decrementStock() {
        const newStock = this.stockSelect.value - 1;
        if (newStock <= 0) {
            this.resetRoom();
        } else {
            this.stockSelect.value = newStock;
            this.elemSelect.nativeElement.value = newStock;
            this.selectedStock(newStock.toString());
        }
    }

    selectedStock(value: string) {
        this.stockSelect.value = parseInt(value);
        this.trackingService.toggleRoomInCart(this.model.room, this.model.line, value);
        this.panierService.add(this.model.room.id, { newTitle: this.model.newTitle, surface: this.model.surface }, this.model.line, parseInt(value), this.model.keybedSelected, this.getValbed(this.model.keybedSelected));
        let elementToAddClass = document.querySelectorAll('.room_' + this.model.room.id);
        [].forEach.call(elementToAddClass, el => {
            if (el !== this) el.classList.add('is_selected');
        });

        setTimeout(function () {
            window.scrollBy({ top: 1, left: 0, behavior: 'smooth' });
        }, 1000);
    }


    /**
     * max stock dispo with stock panier
     * @returns number
     */
    get maxStockDispo(): any {
        let minStock = min(values(this.maxStockArray));
        return minStock;
    }

    /**
     * @returns Array<number>
     */
    get maxStock(): Array<number> {
        let stockFinal = min([this.model.stock, this.model.stockRoom]) + 1;
        return Array.from(Array(stockFinal).keys());
    }

    get maxStockArray(): { engineMax: Number, combineMax: Number, roomMax: Number } {
        let stocks = this.stocks;
        let selectedCount = this.panierService.getStockByIndex(this.model.engine.combine.indexSearch);
        let engineMax = this.model.engine.combine.stock;
        let combineMax = (has(stocks, this.model.engine.alias) ? stocks[this.model.engine.alias] : 0) - this.panierService.getStockByRoomByOta(this.model.room.id, this.model.engine.alias) + selectedCount;
        let roomMax = min([this.model.stockRoom, max(values(stocks))]) - this.panierService.getStockByRoom(this.model.room.id) + selectedCount;

        let results = {
            engineMax: engineMax,
            combineMax: combineMax,
            roomMax: roomMax,
        };
        return results;
    }

    private getValbed(keyBed): Array<any> {
        let valBed = [];
        let bed = this.model.bedding.find((i) => i.key == keyBed);
        if (bed) {
            valBed = JSON.parse(JSON.stringify(bed.value));
        }
        return valBed;
    }

    /**
    * get taux de change
    * @returns number
    */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

    /**
    * has promo
    * @returns boolean has promo
    */
    get hasPromoIQ(): boolean {
        return this.winRef.appConfigSite.promo
    }

    get remise() {
        let remise = 100 - (this.prices.Ttc * 100 / this.model.engine.combine.detailPrice_without_promo.Ttc);
        return Math.round((remise * 100) / 100);
    }
    get prices() {
        return this.winRef.appConfigSite.promo ? this.model.engine.combine.detailPrice : this.model.engine.combine.detailPrice_without_promo
    }
}
